module.exports = __webpack_public_path__ + "assets/img/tree.59ecebc1.svg";